import CityPageTemplate from "@/pages/city-template/CityPageTemplate";
import { hicksvilleConfig } from "./data";

export default function HicksvillePage() {
  return <CityPageTemplate config={hicksvilleConfig} />;
}